import { viewsList } from "../models/viewsList";

export const validateAccessUser = ( typeView, user) => {

    let permissionView = false;

    const permissionsUser = user?.permisos ? user.permisos : [];
    let totalPermissions = 0;

    const viewFind = viewsList.find(({key})=>key === typeView)?.permissions
    if(viewFind){
        viewFind.forEach((permission) => {
            const filter = permissionsUser.filter(({name}) => name === permission)
            if(filter.length > 0){
                totalPermissions = totalPermissions + 1;
            }
        });
    }

    if(totalPermissions ===  viewFind?.length) {
        permissionView = true;
    }

    if(permissionsUser.find(({name})=> name === 'ALL' || name === 'administrador')){
        permissionView = true;
    }

    return permissionView;
}